import { makeApi } from "@zodios/core";
import { z } from "zod";

import { supportRequestSchema } from "@/types/kili/internal/support-request.type.ts";

export const kiliInternalRootApi = makeApi([
  {
    path: "/security/login-to-hospitality/:organizationId", // TODO: Remove (maybe ?) voltadmin from path
    response: z.any(), // 200 + cookie
    parameters: [
      {
        type: "Path",
        name: "organizationId",
        schema: z.number(),
      },
    ],
    alias: "loginToHospitality",
    method: "post",
  },
  {
    path: "/support/submit-ticket",
    response: z.any(), // 200 Ok,
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: supportRequestSchema,
      },
    ],
    alias: "sendSupportRequest",
    method: "post",
  },
]);
